import React from 'react';
import { BsFormControl, BsModalForm } from '../../collection/bootstrap/BootstrapComponents';
import { apiForm, apiGet } from '../../utils/api';

export default function NFCModal(props) {
    const isNew = props.userId < 1;

    const updateData = async () => isNew ? {} : await apiGet("usuarios/get/" + props.userId);

    const saveData = async data => {
        const result = await apiForm("usuarios/editNFC", data);
        if (result) {
            props.onHide();
        }
    }

    return <BsModalForm
        isNew={isNew}
        onUpdate={updateData}
        onSave={saveData}
        modalTitle="Editar código tarjeta"
        show={props.show}
        onHide={props.onHide}
        saveOnEnter>
        <NFCForm />
    </BsModalForm>;
}

function NFCForm(props) {
    const data = props.data;

    return <>
        { /* NFC */}
        <BsFormControl
            label="Código Tarjeta" help="Código reversed hex de la tarjeta" name="codigoPSA"
            value={data.codigoPSA}
            maxLength={14} />
    </>;
}
